import { render, staticRenderFns } from "./ServiceHio.vue?vue&type=template&id=050b0722&scoped=true"
import script from "./ServiceHio.vue?vue&type=script&lang=js"
export * from "./ServiceHio.vue?vue&type=script&lang=js"
import style0 from "./ServiceHio.vue?vue&type=style&index=0&id=050b0722&prod&lang=scss&scoped=true"
import style1 from "./ServiceHio.vue?vue&type=style&index=1&id=050b0722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b0722",
  null
  
)

export default component.exports